import { render, staticRenderFns } from "./ManagersStatusPage.vue?vue&type=template&id=226e3367&scoped=true"
import script from "./ManagersStatusPage.vue?vue&type=script&lang=js"
export * from "./ManagersStatusPage.vue?vue&type=script&lang=js"
import style0 from "./ManagersStatusPage.vue?vue&type=style&index=0&id=226e3367&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226e3367",
  null
  
)

export default component.exports